module.exports = __webpack_public_path__ + "static/assets/c49a09b72784c436f8f7c777e7d8ed5b.svg";